import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const metaDataApi = createApi({
  reducerPath: "metaDataApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API,
    prepareHeaders: (headers) => {
      const user = localStorage.getItem("hthUser");
      const token = user ? JSON.parse(user).token : null;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["MetaData"],
  endpoints: (builder) => ({
    getMetaData: builder.query({
      query: () => "api/admin/getMetaDes",
      providesTags: ["MetaData"],
    }),
    getMetaDataById: builder.query({
      query: (id) => `api/admin/getMeta/${id}`,
      providesTags: (result, error, id) => [{ type: "MetaData", id }],
    }),
    addEditMetaData: builder.mutation({
      query: (data) => ({
        url: "api/admin/addEditMeta",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["MetaData"],
    }),
    deleteMetaData: builder.mutation({
      query: (id) => ({
        url: `api/admin/deletetMeta/${id}`,
        method: "GET",
      }),
      invalidatesTags: ["MetaData"],
    }),
  }),
});

export const { useGetMetaDataQuery, useGetMetaDataByIdQuery, useAddEditMetaDataMutation, useDeleteMetaDataMutation } = metaDataApi;
